import { render } from "./App.vue?vue&type=template&id=23e95c3c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=23e95c3c&lang=less"

import exportComponent from "E:\\KaYu\\掌上推卡app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__